// Policy types
export type PolicyType = 'privacy' | 'terms' | 'refund';

export interface PolicyVersion {
  version: string;
  content: string;
  lastUpdated: string;
}

export interface ConsentStatus {
  privacyAccepted: boolean;
  privacyVersion: string | null;
  privacyAcceptedAt: string | null;
  termsAccepted: boolean;
  termsVersion: string | null;
  termsAcceptedAt: string | null;
  cookieConsentGiven: boolean;
  cookieCategories: CookieCategories | null;
  cookieConsentAt: string | null;
}

export interface CookieCategories {
  necessary: boolean;
  analytics: boolean;
  marketing: boolean;
}

export interface AcceptConsentPayload {
  privacyPolicyVersion: string;
  termsVersion: string;
  cookiePreferences?: CookieCategories;
}

export interface AcceptCookiePayload {
  categories: CookieCategories;
  consentGiven: boolean;
}

// Current policy version - update this when policies change
export const CURRENT_POLICY_VERSION = '2026-04-21';

// API endpoints
const HOST = process.env.REACT_APP_API_HOST || 'http://localhost:8000';

export const POLICY_GET = (type: PolicyType) => `${HOST}/api/policies/${type}`;
export const CONSENTS_STATUS = `${HOST}/api/consents/status`;
export const CONSENTS_ACCEPT = `${HOST}/api/consents/accept`;
export const COOKIE_CONSENT = `${HOST}/api/cookie-consent`;

// localStorage keys
export const PRIVACY_POLICY_ACCEPTED_KEY = 'privacy_policy_accepted';
export const PRIVACY_POLICY_VERSION_KEY = 'privacy_policy_version';
export const TERMS_ACCEPTED_KEY = 'terms_accepted';
export const TERMS_VERSION_KEY = 'terms_version';
export const COOKIE_PREFERENCES_KEY = 'cookie_preferences';
export const COOKIE_CONSENT_KEY = 'cookie_consent';